import { Variants } from "framer-motion";

/** Shared reveal/collapse animation for auth fields that appear mid-flow (OTP, name, password). */
export const formFieldVariants: Variants = {
  initial: {
    height: 0,
    opacity: 0,
    marginBottom: 0,
  },
  animate: {
    height: "auto",
    opacity: 1,
    marginBottom: 16,
    transition: {
      height: {
        duration: 0.3,
      },
      opacity: {
        duration: 0.25,
        delay: 0.15,
      },
    },
  },
  exit: {
    height: 0,
    opacity: 0,
    marginBottom: 0,
    transition: {
      height: {
        duration: 0.3,
      },
      opacity: {
        duration: 0.25,
      },
    },
  },
};
